export default [{
  path: '/workflow',
  component: () => import('@/views/workflow'),
  children: [{
    path: 'workflow-config-notification',
    component: () => import('@/views/workflow/workflow-config-notification/workflow-config-notification-index')
  }]
}]